import { get } from "db/api";

export const searchSubscriptions = async () => {
  try {
    const response = await get("/search-subscriptions");
    const data = await response.json();

    if (!response.ok) {
      console.error("Error en la función:", data.error);
      return;
    }

    return data;
  } catch (error) {
    console.error("Error inesperado:", error.message);
  }
};
